<template>
  <div class="c-controls-resources-listing">
    <div class="grayBox">
      <div class="inner">
        <sc-rich-text class="categoryDescription" :field="category.description" />
      </div>
    </div>
    <div class="inner">
      <div class="items">
        <template v-for="subcategory in category.subcategories" :key="subcategory.id">
          <div v-if="hasSubcategoryItems(subcategory.id)" class="item">
            <h2>{{ subcategory.name?.value }}</h2>
            <sc-rich-text class="subcategoryDescription" :field="subcategory.description" />
            <ul>
              <li v-for="resource in getSubcategoryItems(subcategory.id)" :key="resource.id">
                <a
                  :href="`${resource.item.url}${resource.item.controlsResourceQueryHash?.value}`"
                  >{{ getItemTitle(resource.item) }}</a
                >
              </li>
            </ul>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { formatGuidWithDashes } from '../../../lib/guid';

export default {
  name: 'CIS-Controls-Resources-Listing',
  components: {
    ScRichText: RichText
  },
  props: {
    category: {
      type: Object,
      default: () => ({})
    },
    resources: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    hasSubcategoryItems(subcategoryId) {
      const subcategoryGuid = formatGuidWithDashes(subcategoryId);
      return this.resources.some((r) => subcategoryFilter(subcategoryGuid, r.item));
    },
    getSubcategoryItems(subcategoryId) {
      const subcategoryGuid = formatGuidWithDashes(subcategoryId);
      const items = this.resources
        .filter((r) => subcategoryFilter(subcategoryGuid, r.item))
        .sort((a, b) => {
          const aSortOrder = a.item.controlsResourceSortOrder?.numberValue ?? 9999999;
          const bSortOrder = b.item.controlsResourceSortOrder?.numberValue ?? 9999999;
          // Sort items alphabetically by item title if the controlsResourceSortOrder numbers are the same
          if (aSortOrder === bSortOrder) {
            return this.getItemTitle(a.item).localeCompare(this.getItemTitle(b.item));
          }
          return aSortOrder - bSortOrder;
        });

      return items;
    },
    getItemTitle(item) {
      return (
        item.controlsResourceTitle?.value ||
        item.resourceTitle?.value ||
        item.pageTitle?.value ||
        '---'
      );
    }
  }
};

const subcategoryFilter = (subcategoryGuid, item) => {
  return item?.controlsResourceSubcategories?.value?.indexOf(subcategoryGuid) >= 0;
};
</script>
<style lang="scss" scoped>
.c-controls-resources-listing {
  .grayBox {
    background-color: $box-gray;

    .inner {
      @include exlarge-desktop-up {
        @include padding-x-thin;
      }

      .categoryDescription {
        padding: 2.4rem 2rem;
        color: $gray;

        @include tablet-up {
          padding: 4rem;
        }

        @include desktop-up {
          padding: 4rem 7rem;
        }

        &:deep() {
          p,
          span {
            @include font-styles('Arial', 2rem, 300, normal, 2.6rem, 0, $gray);

            @include tablet-up {
              font-size: 2.8rem;
              line-height: 3.5rem;
            }

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }

  .inner {
    @include exlarge-desktop-up {
      @include padding-x-thin;
    }

    .items {
      padding: 2rem;

      @include tablet-up {
        padding: 2.4rem 4rem;
      }

      @include desktop-up {
        padding: 2.4rem 7rem;
      }

      .item {
        max-width: 118rem;
        @include padding-y(2rem);
        border-bottom: solid 0.1rem $divider;

        @include tablet-up {
          @include padding-y(3rem, 4rem);
        }

        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .subcategoryDescription {
          margin-bottom: 2.4rem;

          &:deep() {
            p,
            span {
              color: $gray;
            }
          }
        }

        h2 {
          font-size: 2.4rem;
          line-height: 3rem;
          margin-bottom: 1.2rem;

          @include tablet-up {
            font-size: 3.6rem;
            line-height: 4.5rem;
          }
        }

        a {
          line-height: 2rem;
        }

        ul {
          list-style: none;
          margin: 0;

          li {
            margin-bottom: 1.6rem;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}
</style>
